import { parseClauses } from '@diagon-alley/common';
import type { FC } from 'react';

import classes from './ClauseText.module.css';

/**
 * Free text laid out as clauses, mirroring `renderClauseBlock` on the document.
 *
 * THE HANGING INDENT IS THE POINT. Rendering terms with `white-space: pre-line` honours the
 * author's line breaks and nothing else, so a numbered clause that wraps continues at the left
 * margin — "requirements" lands under "1." rather than under "The". Each clause gets its own
 * row here, marker beside text, so a wrap aligns under the first word of the clause.
 *
 * SHARED BY BOTH PREVIEWS, and parsed by the same function the renderer uses, so the screen and
 * the page cannot disagree about where a clause starts.
 */
export const ClauseText: FC<{
    text: string | null | undefined;
    /** The heading above this block, so a line merely restating it can be dropped. */
    heading?: string;
}> = ({ text, heading }) => {
    const clauses = parseClauses(text, heading);
    if (clauses.length === 0) return null;

    return (
        <div className={classes.block}>
            {clauses.map((clause, index) => (
                <div className={classes.clause} key={`${clause.marker ?? ''}-${index}`}>
                    {clause.marker && <span className={classes.marker}>{clause.marker}</span>}
                    <span>{clause.text}</span>
                </div>
            ))}
        </div>
    );
};

export default ClauseText;
